import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    warningBox: {
        backgroundColor: '#fff3cd',
        border: '1px solid #ffeaa7',
        borderRadius: '4px',
        padding: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    warningText: {
        color: '#856404',
        fontWeight: 'bold',
    },
    instructionText: {
        marginBottom: theme.spacing(1),
    },
    undoBox: {
        backgroundColor: '#e3f2fd',
        border: '1px solid #2196f3',
        borderRadius: '4px',
        padding: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    undoTitle: {
        color: '#1976d2',
        fontWeight: 'bold',
        marginBottom: theme.spacing(1),
    },
    tipBox: {
        backgroundColor: '#e8f5e8',
        border: '1px solid #4caf50',
        borderRadius: '4px',
        padding: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    tipTitle: {
        color: '#2e7d32',
        fontWeight: 'bold',
        marginBottom: theme.spacing(1),
    }
}));

const SignatureGuideDialog = ({ open, onClose, onReloadReport }) => {
    const classes = useStyles();

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle>
                <Typography variant="h6" style={{ color: '#d32f2f' }}>
                    ⚠️ E-Signature Block Missing
                </Typography>
            </DialogTitle>
            <DialogContent>
                <div className={classes.warningBox}>
                    <Typography className={classes.warningText}>
                        The report cannot be saved because the signature area is modified or has been removed.
                    </Typography>
                </div>

                <Typography variant="body1" className={classes.instructionText}>
                    <strong>Editing Guidelines:</strong>
                </Typography>

                <Typography variant="body2" className={classes.instructionText}>
                    • Make all your edits <strong>ABOVE</strong> the signature section
                </Typography>
                <Typography variant="body2" className={classes.instructionText}>
                    • <strong>DO NOT</strong> modify or delete the signature area at the bottom
                </Typography>
                <Typography variant="body2" className={classes.instructionText}>
                    • If the signature area has been removed, please <strong>UNDO</strong> the changes
                </Typography>
                <Typography variant="body2" className={classes.instructionText}>
                    • You can click <strong>Reload Report</strong> button to reload the report prior to recent changes
                </Typography>
                <Typography variant="body2" className={classes.instructionText}>
                    • <strong>Please note: </strong>Refreshing the page or navigating away before saving will result in <strong>loss of any unsaved changes</strong>. To avoid rework or missing information, ensure all updates are saved before refreshing or exiting the system
                </Typography>


                <div style={{ textAlign: 'center', margin: '20px 0' }}>
                    <div style={{
                        border: '2px dashed #ccc',
                        padding: '20px',
                        borderRadius: '8px',
                        backgroundColor: '#f9f9f9'
                    }}>

                        <Typography variant="body2" style={{ color: 'red', marginBottom: '5px' }}>
                            🚫 <strong>DO NOT MODIFY THIS AREA</strong>
                        </Typography>

                        <div style={{
                            backgroundColor: '#ffebee',
                            padding: '10px',
                            border: '2px solid #f44336',
                            marginBottom: '8px'
                        }}>
                            <Typography variant="body2" style={{ color: '#666', fontSize: '12px' }}>
                               
                                <span style={{paddingRight:"130px"} }>*</span><br/>
                                _________________________<br />
                                Dr. John Smith, M.D.<br />
                                <em>← Required signature area</em>
                            </Typography>
                        </div>
                    </div>
                </div>

                <Typography variant="body2" style={{
                    fontStyle: 'italic',
                    color: '#666',
                    textAlign: 'center',
                    marginTop: '15px'
                }}>
                    If you need help, please contact <strong>acctmgrs@surgicalnotes.com</strong> or call <strong>1-800-866-0656</strong>
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={onReloadReport}
                    color="secondary"
                    variant="outlined"
                >
                    Reload Report
                </Button>
                <Button
                    onClick={onClose}
                    color="primary"
                    variant="contained"
                    autoFocus
                >
                    Continue Editing
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SignatureGuideDialog;


// WEBPACK FOOTER //
// ./src/components/SignatureGuideDialog.js